import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen } from "@fortawesome/free-solid-svg-icons";

import Legel_Entity_view_offcanvas from "../legel_Entity_view_offcanvas/Legel_Entity_view_offcanvas";
import Legel_Entity_Edit_offcanvas from "../legel_Entity_Edit_offcanvas/Legel_Entity_Edit_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Legel_Entity_table() {
  const [view, setView] = useState(false);
  const [showEdit, setEdit] = useState(false);

  const data = [
    {
      legalEntityName: "NLC INDIA LIMITED",
      legalEntityType: "Companies Act",
      dateOfEstablishment: "14 JAN 2025",
      otherAccreditations: "_ _ _",
    },
  ];
   const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Legal Entity Name</th>
                  <th>Legal Entity Type</th>
                  <th>Date Of Establishment</th>
                  <th>Other Accreditations</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    {/* Legal Entity Name */}
                    <td>{row.legalEntityName}</td>

                    {/* Legal Entity Type */}
                    <td>{row.legalEntityType}</td>

                    {/* Date Of Establishment */}
                    <td>{row.dateOfEstablishment}</td>

                    {/* Other Accreditations */}
                    <td>{row.otherAccreditations}</td>

                    {/* Action */}
                    <td>
                      <div className="action_icons">
                        <FontAwesomeIcon
                          icon={faEye}
                          onClick={() => setView(true)}
                        />
                        <FontAwesomeIcon
                          icon={faPen}
                          onClick={() => setEdit(true)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>

      {/* VIEW */}
      <Legel_Entity_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
      />

      {/* Edit */}
      <Legel_Entity_Edit_offcanvas
        show={showEdit}
        handleClose={() => setEdit(false)}
      />
    </>
  );
}

export default Legel_Entity_table;
